import { useProjectsControllerGet } from '@batiflow/api-client';
import { FilesWorkspace } from '@/features/documents';
import { canManageSpace, type Space } from './model';

export interface SpaceDocumentsTabProps {
  space: Space;
  /** The organisation of the reader, or null in another organisation's space. */
  readerOrgId: string | null;
}

/**
 * The Documents tab of a shared space: the folder workspace of the project's Files tab, by space
 * id. For a member of the host organisation it also knows the project (its code names new files,
 * the viewer opens); for an external reader nothing at the organisation level is read.
 */
export function SpaceDocumentsTab({ space, readerOrgId }: SpaceDocumentsTabProps) {
  const projectId = readerOrgId !== null ? space.projectId : null;
  // The project's code is only a naming helper: a refusal (not on the project) leaves it empty.
  const project = useProjectsControllerGet(readerOrgId ?? '', projectId ?? '', {
    query: { enabled: projectId !== null },
  });
  return (
    <FilesWorkspace
      orgId={readerOrgId}
      projectId={projectId}
      projectCode={project.data?.code ?? null}
      spaceId={space.id}
      projectManager={canManageSpace(space)}
    />
  );
}
